import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isSignedIn } from "./auth/auth";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isSignedIn() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/signin",
          }}
        />
      )
    }
  />
);

export default PrivateRoute;
